// src/db/models/performanceModel.js
import { api } from '../../api/client';

// Modified normalizePerformance function in performanceModel.js
const normalizePerformance = (perf) => {
  // Normalize isComplete
  const isComplete = perf.isComplete === 1 ||
                     perf.isComplete === true ||
                     (typeof perf.isComplete === 'string' && perf.isComplete.toLowerCase() === 'true');
  
  // Normalize tts_enabled
  const ttsEnabled = perf.tts_enabled === 1 ||
                     perf.tts_enabled === true ||
                     (typeof perf.tts_enabled === 'string' && perf.tts_enabled.toLowerCase() === 'true') ||
                     perf.ttsEnabled === 1 ||
                     perf.ttsEnabled === true ||
                     (typeof perf.ttsEnabled === 'string' && perf.ttsEnabled.toLowerCase() === 'true');
  
  return {
    id: perf.id,
    learnerAccountId: perf.learner_account_id ?? perf.learnerAccountId ?? null,
    studentName: perf.student_name,
    assessmentName: perf.assessment_type,
    assessmentKind: perf.assessment_kind,
    gradeLevel: perf.grade_level,
    actualGradeLevel: perf.actual_grade_level,
    gradePerformance: perf.grade_performance,
    codeUsed: perf.code_used,
    testDate: perf.test_date,
    testTime: perf.test_time,
    isComplete: isComplete,
    tts_enabled: ttsEnabled ? 1 : 0  // Standardize to 1 or 0
  };
};

export const PerformanceModel = {
  async create(performanceData) {
    const normalizedData = {
      ...performanceData,
      code_used: performanceData.codeUsed || performanceData.code_used,
      assessment_kind: performanceData.assessmentKind || performanceData.assessment_kind || 'gradeLevel',
      continue_code: performanceData.continueCode || null,
      isComplete: performanceData.isComplete ? 1 : 0,
    };
    return api.createPerformance(normalizedData);
  },

  async findAll(filters = {}) {
    return api.getPerformances(filters);
  },

  async getStats() {
    try {
      const performances = await this.findAll();
      
      const uniqueStudents = new Set(
        performances
          .map(p => {
            if (p.student_name && p.actual_grade_level) {
              return `${p.student_name.trim().toLowerCase()}_${p.actual_grade_level.trim().toLowerCase()}`;
            }
            return null;
          })
          .filter(Boolean)
      );

      const studentsByGrade = new Map();
      performances.forEach(p => {
        if (p.student_name && p.actual_grade_level) {
          const grade = p.actual_grade_level.trim();
          const key = `${p.student_name.trim().toLowerCase()}_${grade.toLowerCase()}`;
          if (!studentsByGrade.has(grade)) {
            studentsByGrade.set(grade, new Set());
          }
          studentsByGrade.get(grade).add(key);
        }
      });

      const gradeBreakdown = {};
      studentsByGrade.forEach((students, grade) => {
        gradeBreakdown[grade] = students.size;
      });

      return {
        totalPerformances: performances.length,
        uniqueStudents: uniqueStudents.size,
        gradeBreakdown
      };
    } catch (error) {
      console.error('Error getting stats:', error);
      return {
        totalPerformances: 0,
        uniqueStudents: 0,
        gradeBreakdown: {}
      };
    }
  },

  async update(id, performanceData) {
    const payload = { ...performanceData };
    if (Object.hasOwn(performanceData, 'isComplete')) {
      payload.isComplete = performanceData.isComplete ? 1 : 0;
    }
    return api.updatePerformance(id, payload);
  },

  normalize: normalizePerformance
};
